<app-navbar-style-three></app-navbar-style-three>

<section class="admission-page" style="font-family: 'Li Ador Noirrit SemiBold'; padding: 0;">
  <div class="admission-overlay"></div>

  <div class="admission-image-container" style="position: relative; width: 100%; overflow: hidden;">
    <img src="/assets/img/school/MTTSAAdmission.png" alt="Admission Background" style="width: 100%; height: auto; display: block; min-height: 800px; object-fit: cover; object-position: center bottom;">

    <div class="admission-table-panel" style="position: absolute; top: 10%; left: 50%; transform: translateX(-50%); width: 90%; max-width: 600px; border: 3px solid black; margin: 0; z-index: 10;">
      <div class="panel-top">
        <div class="panel-title">
          <div class="row-left">
            <span class="row-icon"><i class="fa fa-graduation-cap"></i></span>
            <h2>শিক্ষাক্রম ও স্তরসমূহ</h2>
          </div>
        </div>
        <div class="panel-label">অনলাইন ভর্তি আবেদন</div>
      </div>

      <div class="table-body">
        <div class="table-row">
          <div class="row-left">
            <span class="row-icon"><i class="fa fa-user"></i></span>
            ইবতেদায়ী শিক্ষাধারা
          </div>
          <div class="row-right">
            <a href="#" class="apply-button">আবেদন করুন</a>
          </div>
        </div>

        <div class="table-row">
          <div class="row-left">
            <span class="row-icon"><i class="fa fa-book"></i></span>
            দাখিল শিক্ষাধারা
          </div>
          <div class="row-right">
            <a href="#" class="apply-button">আবেদন করুন</a>
          </div>
        </div>

        <div class="table-row">
          <div class="row-left">
            <span class="row-icon"><i class="fa fa-graduation-cap"></i></span>
            আলিম শিক্ষাধারা
          </div>
          <div class="row-right">
            <a href="#" class="apply-button">আবেদন করুন</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>